import { ShieldCheck, Truck, Sparkles, Award } from "lucide-react";
import { Link } from "react-router-dom";
import { IMG } from "@/data/catalog";
import { Reveal, SectionHeading, Btn, AddToCartButton, Overline } from "@/components/common/ui";
import { FloatingDecor } from "@/components/common/Decor";

const VALUES = [
  [Truck, "Free Express Shipping", "Tracked, from our Gold Coast studio"],
  [ShieldCheck, "30-Day Money Back", "Love it or return it, hassle-free"],
  [Award, "12-Month Warranty", "Every device fully covered"],
  [Sparkles, "FDA Cleared Tech", "Clinically-backed wavelengths"],
];

export const ValueStrip = () => (
  <section className="border-b border-[#F2E8E6] bg-[#FFFCFA]" data-testid="value-strip">
    <div className="mx-auto grid max-w-[1400px] grid-cols-2 gap-px bg-[#F2E8E6] md:grid-cols-4">
      {VALUES.map(([Icon, t, d]) => (
        <div key={t} className="flex flex-col items-center gap-2 bg-[#FFFCFA] px-4 py-8 text-center">
          <Icon className="h-6 w-6 text-[#FBC4A8]" strokeWidth={1.5} />
          <p className="text-sm font-medium text-[#2C2B2C]">{t}</p>
          <p className="text-xs text-[#8A7F86]">{d}</p>
        </div>
      ))}
    </div>
  </section>
);

export const GuaranteeBlock = () => (
  <section className="bg-white py-24 md:py-32" data-testid="guarantee-block">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <div className="grid items-center gap-12 rounded-[2rem] border border-[#F2E8E6] bg-white p-8 md:grid-cols-2 md:p-0">
        <div className="md:p-16">
          <Overline>The Aura Glow Guarantee</Overline>
          <h2 className="mt-4 font-display text-4xl font-normal leading-tight text-[#2C2B2C] sm:text-5xl">
            Glow with <span className="italic text-[#FBC4A8]">complete</span> confidence.
          </h2>
          <p className="mt-5 max-w-md text-base font-light leading-relaxed text-[#8A7F86]">
            Every Leopard Luxe™ mask arrives beautifully packaged with adjustable straps, USB-C cable, a silk carry bag and user guide, protected by a 30-night money-back guarantee and 12-month warranty.
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <AddToCartButton sku="single" label="Shop the Mask" testid="guarantee-add" />
            <Btn to="/science" variant="outline" testid="guarantee-science">The Science</Btn>
          </div>
        </div>
        <div className="hover-zoom overflow-hidden md:h-[34rem]">
          <img src={IMG.leopardSilk} alt="Leopard Luxe LED mask" className="h-full w-full object-cover" />
        </div>
      </div>
    </div>
  </section>
);

export const FinalCta = () => (
  <section className="relative overflow-hidden bg-[#232222] py-28 text-center text-[#FFFCFA] md:py-40 grain" data-testid="final-cta">
    <img src={IMG.leopardSilk} alt="" className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-[0.12]" />
    <FloatingDecor />
    <div className="relative z-10 mx-auto max-w-3xl px-6">
      <Overline>Your glow ritual awaits</Overline>
      <h2 className="mt-5 font-display text-5xl font-normal leading-[0.98] tracking-tight sm:text-7xl">
        Fall in love with<br /><span className="text-[#FBC4A8]">your skin again.</span>
      </h2>
      <p className="mx-auto mt-6 max-w-lg text-base font-light text-[#FFFCFA] md:text-lg">
        Join 50+ women glowing brighter in just 10 minutes a day. Free express shipping and a 30-night money-back guarantee, always.
      </p>
      <div className="mt-9 flex flex-wrap justify-center gap-4">
        <AddToCartButton sku="single" label="Add to Bag" variant="accent" testid="final-cta-add" />
      </div>
    </div>
  </section>
);
